import { useMemo } from 'react';
import { REGION_US } from 'modules/project/CreateProject/constant';

/**
 * Hook to encapsulate region selection logic.
 * @param availableRegions Array of region strings in the format 'REGION::domain'
 * @returns { regionDomainMap, selectedRegion }
 */
export function useRegionSelection(availableRegions: string[]) {
  const regionDomainMap = useMemo(() => {
    const regionMap = new Map<string, string>();
    availableRegions.map((region) => {
      const [key, value] = region.split('::');
      if (key && value !== undefined) {
        regionMap.set(key.trim(), value.trim());
      }
    });
    return regionMap;
  }, [availableRegions]);

  const selectedRegion = useMemo(() => {
    // Find the region that matches the current window location origin
    const region = Array.from(regionDomainMap.entries()).find(
      ([, value]) => value === window.location.origin
    );
    return region ? region[0] : REGION_US;
  }, [regionDomainMap]);

  return { regionDomainMap, selectedRegion };
}
